import { USER_KEY } from "../config";
import { getToken, setToken, clearToken } from "../api/http";

export const SET_AUTH = "SET_AUTH";
export const SET_USER = "SET_USER";
export const LOGOUT = "LOGOUT";

const initialUser = (() => {
	try {
		return JSON.parse(localStorage.getItem(USER_KEY) || "null");
	} catch {
		return null;
	}
})();

const initialState = {
	isAuthenticated: !!getToken(),
	user: initialUser,
};

export function authReducer(state = initialState, action) {
	switch (action.type) {
		case SET_AUTH:
			return { ...state, isAuthenticated: true };
		case SET_USER:
			return { ...state, user: action.payload };
		case LOGOUT:
			return { ...state, isAuthenticated: false, user: null };
		default:
			return state;
	}
}

export const loginSuccess = (token, user) => (dispatch) => {
	setToken(token);
	if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
	dispatch({ type: SET_AUTH });
	dispatch({ type: SET_USER, payload: user });
};

export const setUser = (user) => (dispatch) => {
	localStorage.setItem(USER_KEY, JSON.stringify(user));
	dispatch({ type: SET_USER, payload: user });
};

export const logout = () => (dispatch) => {
	clearToken();
	localStorage.removeItem(USER_KEY);
	dispatch({ type: LOGOUT });
};
